import { render, staticRenderFns } from "./number-slider.vue?vue&type=template&id=a8391dae&"
import script from "./number-slider.vue?vue&type=script&lang=ts&"
export * from "./number-slider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8391dae')) {
      api.createRecord('a8391dae', component.options)
    } else {
      api.reload('a8391dae', component.options)
    }
    module.hot.accept("./number-slider.vue?vue&type=template&id=a8391dae&", function () {
      api.rerender('a8391dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/number-slider/number-slider.vue"
export default component.exports